// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import calendar from '@src/views/calendar/store/reducer'

const rootReducer = {
  auth,
  navbar,
  layout,
  calendar
}

export default rootReducer
